import voiceLineSvg from '@listening/assets/astro/images/voice-line.svg';
import { ClientOnly } from '@tanstack/react-router';

export function ResearchPapersVideo() {
  return (
    <ClientOnly>
      <section className='flex w-full items-center justify-center'>
        <div className='mt-10 flex h-auto w-full max-w-[1050px] items-center justify-center'>
          <div className='size-full'>
            <script
              async
              src='https://fast.wistia.com/embed/medias/oahv8zh3p7.jsonp'
            />
            <script
              async
              src='https://fast.wistia.com/assets/external/E-v1.js'
            />
            <div
              className='wistia_responsive_padding'
              // style="padding: 56.25% 0 0 0; position: relative"
              style={{
                padding: '56.25% 0 0 0',
                position: 'relative',
              }}
            >
              <div
                className='wistia_responsive_wrapper'
                // style="
                //     height: 100%;
                //     left: 0;
                //     position: absolute;
                //     top: 0;
                //     width: 100%;
                //   "
                style={{
                  height: '100%',
                  left: 0,
                  position: 'absolute',
                  top: 0,
                  width: '100%',
                }}
              >
                <div
                  className='wistia_embed wistia_async_oahv8zh3p7 seo=true videoFoam=true'
                  style={{
                    height: '100%',
                    position: 'relative',
                    width: '100%',
                  }}
                  // style="height: 100%; position: relative; width: 100%"
                  suppressHydrationWarning
                >
                  <div
                    className='wistia_swatch'
                    style={{
                      height: '100%',
                      left: 0,
                      opacity: 0,
                      overflow: 'hidden',
                      position: 'absolute',
                    }}
                    suppressHydrationWarning
                  >
                    <img
                      alt='Wistia'
                      aria-hidden='true'
                      src='https://fast.wistia.com/embed/medias/oahv8zh3p7/swatch'
                      style={{
                        filter: 'blur(5px)',
                        height: '100%',
                        objectFit: 'contain',
                        width: '100%',
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <img
            alt='Voice Line'
            className='absolute left-0 z-[-1] h-[71px] w-full object-cover'
            loading='lazy'
            src={voiceLineSvg}
          />
        </div>
      </section>
    </ClientOnly>
  );
}
